var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleWavyCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.808 25.192c-1.15-1.15-.388-3.566-.973-4.98C5.228 18.743 3 17.562 3 16c0-1.563 2.228-2.744 2.835-4.211.585-1.415-.178-3.83.973-4.981 1.15-1.15 3.566-.388 4.98-.973C13.257 5.228 14.438 3 16 3c1.563 0 2.744 2.228 4.211 2.835 1.416.585 3.83-.178 4.981.973 1.15 1.15.388 3.566.973 4.98C26.773 13.257 29 14.438 29 16c0 1.563-2.228 2.744-2.835 4.211-.585 1.416.178 3.83-.973 4.981-1.15 1.15-3.566.388-4.98.973C18.743 26.773 17.562 29 16 29c-1.563 0-2.744-2.228-4.211-2.835-1.415-.585-3.83.178-4.981-.973z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 13l-7.333 7-3.667-3.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgCircleWavyCheck;